import React, { useState, useEffect } from "react";

const MAX_SUBMISSIONS = 5; // Max attempts per user

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [submissionCount, setSubmissionCount] = useState(0);

  useEffect(() => {
    const storedCount = localStorage.getItem("contactSubmissionCount");
    if (storedCount) {
      setSubmissionCount(parseInt(storedCount, 10));
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }
    if (!formData.message.trim()) newErrors.message = "Message cannot be empty.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (submissionCount >= MAX_SUBMISSIONS) {
      setErrors({ form: "Submission limit reached (5 times). Try later." });
      return;
    }

    try {
      const response = await fetch("https://formspree.io/f/xbldowka", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSuccessMessage("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });

        const newCount = submissionCount + 1;
        setSubmissionCount(newCount);
        localStorage.setItem("contactSubmissionCount", newCount);
      } else {
        setErrors({ form: "Failed to send message. Try again later." });
      }
    } catch (error) {
      setErrors({ form: "Network error. Try again later." });
    }
  };

  return (
    <section
      id="contact"
      className="py-16 flex justify-center items-center min-h-screen px-4"
      style={{
        backgroundColor: "#fdf2f8", // Very light pink background matching Home section
      }}
    >
      <div className="bg-white p-10 md:p-12 rounded-2xl shadow-2xl max-w-3xl w-full">
        {/* 🚀 Responsive Heading */}
        <h2 className="text-4xl md:text-3xl font-extrabold text-center text-gray-900 mb-4">
          CONTACT <span className="text-purple-600">ME</span>
        </h2>
        <p className="text-center text-gray-600 mt-2">
          Feel free to contact me using the form below.
        </p>

        {successMessage && (
          <p className="text-green-600 text-center mb-4 font-semibold">{successMessage}</p>
        )}
        {errors.form && (
          <p className="text-red-500 text-center mb-4 font-semibold">{errors.form}</p>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name Field */}
          <div>
            <label className="block text-gray-700 font-semibold">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
              placeholder="Enter Your Name"
            />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
          </div>

          {/* Email Field */}
          <div>
            <label className="block text-gray-700 font-semibold">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
              placeholder="Enter Your Email"
            />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
          </div>

          {/* Message Field */}
          <div>
            <label className="block text-gray-700 font-semibold">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
              placeholder="Enter Your Message"
            ></textarea>
            {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`w-full py-4 rounded-lg shadow-md font-semibold transition-all text-lg ${
              submissionCount >= MAX_SUBMISSIONS
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : "bg-purple-600 text-white hover:bg-purple-700"
            }`}
            disabled={submissionCount >= MAX_SUBMISSIONS}
          >
            {submissionCount >= MAX_SUBMISSIONS ? "Limit Reached" : "Send Message"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;